export default class BookingHeaderPlus {
    static init(): void {
        const form = document.querySelector('#booking-header-form') as HTMLFormElement;
        if (!form) return;

        const formPlus = form.querySelector('.form-number__plus') as HTMLFormElement;
        if (!formPlus) return;

        const peopleInput = form.querySelector('#booking-header__people') as HTMLInputElement;

        this.updatePlusImage(peopleInput);
        peopleInput.addEventListener('input', () => {
            this.updatePlusImage(peopleInput);
        });
    }

    static updatePlusImage(peopleInput: HTMLInputElement) {
        const form = document.querySelector('#booking-header-form') as HTMLFormElement;
        const formPlus = form.querySelector('.form-number__plus') as HTMLFormElement;
        const peopleInputValue = parseInt(peopleInput.value);
        const plusImage = formPlus.querySelector('img') as HTMLImageElement;
        const plusInfoText = formPlus.querySelector('.info-text') as HTMLSpanElement;

        if (peopleInputValue >= 10) {
            formPlus.classList.add('form-number__plus--disabled');
            plusImage.classList.add('d-none');
            plusInfoText.classList.remove('d-none');
        } else {
            formPlus.classList.remove('form-number__plus--disabled');
            plusImage.classList.remove('d-none');
            plusInfoText.classList.add('d-none');
        }
    }

}
